import { useFadeInScroll } from "../../components/Animation/fadeinScroll";
const benefits = [
  ["Controlled Support", "Targeted stabilization with guided movement."],
  ["Superior Airflow", "Breathable structure reduces irritation."],
  ["Waterproof", "Maintain hygiene with confidence."],
  ["Adjustable Comfort", "Adapts to swelling changes."],
  ["Clip-On Design", "Easy application and follow-ups."],
  ["Personalized Fit", "Custom sizing and color options."],
];

const InnovationBenefits = () => {
   const title = useFadeInScroll<HTMLDivElement>();
  return (
    <section className="sm:px-12 bg-white">
        <div
            ref={title.ref}
            className={`
              transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]
              ${title.isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-6"}
            `}
          >
      <h2
          className="
            text-primary font-semibold leading-tight
            text-[1.6rem]
            sm:text-[2.1rem]
            md:text-[2.5rem]
            lg:text-[2.8rem]
            xl:text-[3rem]
            mb-4 sm:mb-5
            text-center
          "
        >
        Key Benefits
      </h2>

      <p className="text-center text-text-secondary mt-4 mb-4 max-w-2xl mx-auto">
        Engineered to enhance comfort, mobility, and healing—without
        compromising clinical integrity.
      </p>
</div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {benefits.map(([title, desc], i) => (
          <div
            key={i}
            className="border border-primary/40 rounded-2xl p-6 bg-[#F6F7F7] text-center hover:shadow-md transition"
          >
            <h3 className="text-lg font-semibold mb-3">{title}</h3>
            <p className="text-text-secondary text-sm leading-relaxed max-w-sm mx-auto">
              {desc}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-16 text-center">
         
        <p className="text-text-secondary max-w-2xl mx-auto mb-4">
          At Sacrum, every innovation is driven by better healing and better outcomes.
        </p>
        <h3 className="text-2xl md:text-3xl font-bold text-primary">
          Join us on the path to a healthier recovery.
        </h3>
        </div>
    </section>
  );
};

export default InnovationBenefits;
